import type { GetInternalAuditImpactRatingByIdResponseRow } from '@risksmart-app/trpc/src/types';
import type { GetInternalAuditImpactRatingByIdQuery } from '@risksmart-app/web-graphql-client/generated/graphql';
import { GetInternalAuditImpactRatingByIdDocument } from '@risksmart-app/web-graphql-client/generated/graphql';
import { createQueryHook } from 'src/utils';

type UseGetInternalAuditImpactRatingByIdArgs = {
  id: string;
};

export const useGetInternalAuditImpactRatingById = createQueryHook<
  UseGetInternalAuditImpactRatingByIdArgs,
  GetInternalAuditImpactRatingByIdResponseRow[],
  GetInternalAuditImpactRatingByIdQuery
>({
  trpcQueryOptions: (trpc, { id }) =>
    trpc.frontend.impactRating.internalAuditImpactRatingById.queryOptions({
      id,
    }),
  mapTrpcDataToGraphQL: (data) => ({ impact_internal_audit_rating: data }),
  graphqlDocument: GetInternalAuditImpactRatingByIdDocument,
  graphqlVariables: ({ id }) => ({ id }),
});
